module.exports = __webpack_public_path__ + "img/service_img_4.3b6f8c2e.png";